import React, { useState } from 'react';
import classNames from 'classnames';
import PhotoView from './PhotoView';
import { BACKEND_URL } from '../../../configs';

export default function ViolationGallery({ photos = [], className = '' }) {
  const [selected, setSelected] = useState(null);
  // const photos = ['https://img-webcalypt.ru/img/thumb/lg/5187/20254/QlndSdh8EcX8aFIVIbsv5aeN4G3HOp85kMCEEjWe9gMi5iJ53vmqC88yvDDubslQDUdniKeOHtoUyweOUA5zdgwY3K3CjR4NrNuDXCblcF5xAZA2R6Z4zSW8ndtcjCUw.jpeg.jpg'];
  return (
    <div className={classNames('gallery', className)}>
      <div className="gallery-photos-wrapper">
        {photos.map((photo, index) => (
          <div key={index} className="photo-item" onClick={() => setSelected(selected === photo ? null : photo)}>
            <div className="photo" style={{ backgroundImage: `url(${photo && photo.startsWith('http') ? photo : `${BACKEND_URL}/violations/image/${photo}`})` }} />
          </div>
        ))}
      </div>
      {selected ? <PhotoView photo={selected} onClose={() => setSelected(null)} /> : null}
    </div>
  );
}
